import { GridSortModel } from '@mui/x-data-grid-pro';
import { parseJson } from '@/lib/common';
import {
  FilterGroup,
  FilterInput,
  LogicalOperator,
} from '@/components/publicSearch/constants';
import { PUBLIC_SEARCH_STATE_PARAM } from '@/lib/saleCataloguePaths';
import {
  deserializePublicSearchFilterState,
  type SerializedPublicSearchState,
} from '@/lib/publicSearchUrlCodec';

export type ParsedPublicSearchUrlState = {
  filters: FilterInput[];
  filterGroups: FilterGroup[];
  commonFilterOperator: LogicalOperator;
  groupsOperator: LogicalOperator;
  gridSortModel: GridSortModel;
};

export function parsePublicSearchUrlState(
  searchParams: URLSearchParams | string | null | undefined,
): ParsedPublicSearchUrlState | null {
  const raw =
    typeof searchParams === 'string'
      ? new URLSearchParams(searchParams).get(PUBLIC_SEARCH_STATE_PARAM)
      : searchParams?.get(PUBLIC_SEARCH_STATE_PARAM);

  if (!raw) return null;

  const parsed = parseJson(raw, null) as SerializedPublicSearchState | null;
  if (!parsed || typeof parsed !== 'object') return null;

  return deserializePublicSearchFilterState(parsed);
}
